<template>
    <div class="h-title">
        Invitation no longer available.

    </div>
</template>
  
  <script>
  import { onMounted } from "vue";
  
  export default {
    setup() {
  
    
  
     
   
  
      onMounted(() => {
      
      });
     
      return {
        
      };
    },
  };
  </script>
    